import { render, staticRenderFns } from "./FaceCheckList.vue?vue&type=template&id=b1d760b8&scoped=true"
import script from "./FaceCheckList.vue?vue&type=script&lang=js"
export * from "./FaceCheckList.vue?vue&type=script&lang=js"
import style0 from "./FaceCheckList.vue?vue&type=style&index=0&id=b1d760b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d760b8",
  null
  
)

export default component.exports